import React  from 'react';
import './App.css';
import BoardLang from './BoardLang.json';

import { useNavigate } from "react-router-dom";

class BoardNewComment extends React.Component {

	constructor(props) {

		super(props);
		
		this.state = {
			commentText: "",
		};

		this.onCommentTextChanged = this.onCommentTextChanged.bind(this);
		this.serverInsertBoardComment = this.serverInsertBoardComment.bind(this);
		this.onClickSaveButton = this.onClickSaveButton.bind(this);
		this.onClickCancelButton = this.onClickCancelButton.bind(this);
	}
	
	onCommentTextChanged(value) {
		this.setState({commentText: value});
	}

	async serverInsertBoardComment(boardID, userID, userName, commentText) {

		var baseURLAPI = this.props.baseURLAPI;
		var url = baseURLAPI + "/insertboardcommentrecord?boardid=" + boardID;
		url = url + "&userid=" + userID;
		url = url + "&username=" + encodeURIComponent(userName);
		url = url + "&commenttext=" + encodeURIComponent(commentText);
		
		const res = await fetch(url);
		await res.text();

		this.props.showToast(this.props.getLang(BoardLang, "newCommentSaved"));
		this.props.setSelectedTab("info");
	}
		
	async serverCheckIfBoardExistsYN(boardNumber) {

		var baseURLAPI = this.props.baseURLAPI;
		var url = baseURLAPI + "/getboarddatafromboardnumber?boardnumber=" + boardNumber;
		
		const res = await fetch(url);
		const textResponse = await res.text();

		if (textResponse === "[]") {
			return false;
		} else {
			return true;
		}
	}
	
	async onClickSaveButton() {
		
		var commentText = this.state.commentText;
		if (commentText === "") {
			this.props.showToast(this.props.getLang(BoardLang, "commentTextEmpty"));
			return;
		}
		
		var userID = this.props.userID;
		var userName = this.props.firstName + " " + this.props.lastName;
		userName = userName.trim();
		if (userName === "") {
			userName = this.props.email;
		}	

		this.serverInsertBoardComment(this.props.boardID, userID, userName, commentText);
	}
	
	onClickCancelButton() {
		this.props.setSelectedTab("info");
	}
	
	render() {		
		return (
			<div className="ViewContainer1">
				<div style={{height: "30px"}}></div>
				<div className="ViewTopTitle">{this.props.getLang(BoardLang, "newComment")}</div>
				<div className="ViewTopText">{this.props.getLang(BoardLang, "newCommentInfoText")}</div>

				<div style={{height: "30px"}}></div>
				<div className="ViewBlockContainer">
					<div style={{height: "15px"}}></div>
					<div className="ViewBlockTitle">{this.props.getLang(BoardLang, "comment")}</div>
					<div style={{height: "20px"}}></div>
					<div className="ViewContainer2">
						<fieldset className="ViewItemFieldset">
							<legend className="ViewItemLegend">{this.props.getLang(BoardLang, "boardNumber")}</legend> 
							<input
								className="ViewItemInput" 
								id="boardNumber" 
								type="text" 
								defaultValue={this.props.boardNumber}
								disabled={true}
							/>
						</fieldset>
						<div style={{height: "10px"}}></div>
						<fieldset className="ViewItemFieldset">
							<legend className="ViewItemLegend">{this.props.getLang(BoardLang, "comment")}</legend> 
							<textarea
								className="ViewItemInput" 
								id="commentText" 
								rows={15}
								autoFocus={true}
								onChange={(event) => this.onCommentTextChanged(event.target.value)}
							/>
						</fieldset>
					</div>
					<div style={{height: "60px"}}></div>
					<div className="ViewContainerButtons">
						<div style={{width: "200px"}}></div>
						<button className="ViewCancelButton" onClick={this.onClickCancelButton}>{this.props.getLang(BoardLang, "cancel")}</button>
						<div style={{width: "20px"}}></div>
						<button className="ViewSaveButton" onClick={this.onClickSaveButton}>{this.props.getLang(BoardLang, "save")}</button>
					</div>
					<div style={{height: "50px"}}></div>
				</div>

				<div style={{height: "100px"}}></div>
			</div>
		);
	}
}

export default function BoardNewCommentFunction(props) {
	const navigate = useNavigate();
	return <BoardNewComment {...props} navigate={navigate} />;
}

